import { mapGetters } from 'vuex'
import config from 'services/config'

export default {
    computed: {
        ...mapGetters({
            areStatisticsCookiesEnabled: 'Hubspot/hubspotChatIsAvailable',
            unreadConversationsCount: 'Hubspot/unreadConversationCount',
            cookieBotReady: 'Hubspot/cookieBotReady',
            hubspotChatIsOpen: 'Hubspot/hubspotChatIsOpen',
            cookieInfoVisible: 'Hubspot/cookieInfoVisible'
        }),
        hubspotDisabledMessage () {
            return this.$t('HubspotDisabled.chat_disabled_message',
                { acceptCookies: `<a style="color: #C65300; font-weight: bold; text-decoration: underline;" href="javascript: Cookiebot.show()">${this.$t('HubspotDisabled.accept_cookies')}</a>` })
        },
    },
    methods: {
        toggleChat () {
            if (config.chatBotNewUIEnabled) {
                this.$store.dispatch('Hubspot/toggleChat')
            } else {
                window.HubSpotConversations.widget.open()
            }
        },
        closeCookieInfo () {
            this.$store.dispatch('Hubspot/closeCookieInfo')
        }
    }
}
